import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import '../../stylesheets/Reports.css'
import '../../stylesheets/UserManagement.css'
import '../../stylesheets/History.css'
import Toolbar from '../Toolbar';
import Sidebar from '../Sidebar';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from "react-router-dom";
import { HistoryAPI } from "../../axios";

const PieChart = () => {
  const navigate = useNavigate();

  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [countries, setCountries] = useState([]);
  const [message, setMessage] = useState("");
  const [showChart, setShowChart] = useState(true);
  const [options, setOptions] = useState({
    chart: {
      type: 'pie',
    },
    labels: labels,
    colors: ['#FF4560', '#00E396', '#008FFB', '#FF9F00', '#775DD0'], // Customize colors
    legend: {
      show: false, // Hide the legend in the chart
    },
    plotOptions: {
      pie: {
        donut: {
          size: '10%', // Adjust donut size if needed
        },
      },
    },
    tooltip: {
      theme: 'dark',
      x: {
        show: false,
      },
      y: {
        formatter: (value) => `${value} units`, // Customize tooltip text
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels inside the chart
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: '100%',
          },
        },
      },
    ],
  });

  useEffect(() => {
    setOptions(prevOptions => ({
      ...prevOptions,
      labels: labels,
    }));
  }, [labels]);

  useEffect(() => {
    const fullCountryList = countryList().getData().map(country => ({
      label: country.label,
      value: country.label,
    }));
    setCountries(fullCountryList);
  }, []);

  useEffect(() => {
    HistoryAPI.fetch_data_history('Pakistan', '2024-09-02', null)
      .then((res) => {
        const countSeries = res.data.convertedArrayForFirstColumn.map(element => element.count);
        const labelsData = res.data.convertedArrayForFirstColumn.map(element => element.label);
        setSeries(countSeries);
        setLabels(labelsData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  
  const handleSubmit = (values) => {
    console.log('Form data', values);
    HistoryAPI.fetch_data_history(values.location, values.customDate, null)
    .then((res) => {
      const countSeries = res.data.convertedArrayForFirstColumn.map(element => element.count);
      const labelsData = res.data.convertedArrayForFirstColumn.map(element => element.label);
      setSeries(countSeries);
      setLabels(labelsData);
    })
    .catch((err) => {
      console.log(err);
    });
  };
  
  useEffect(() => {
    if (labels.length === 0 || series.length === 0) {
      setMessage("There is no records available for these parameters");
      setShowChart(false);
    } else {
      setMessage("");
      setShowChart(true);
    }
  }, [labels, series]);

  const handleFieldChange = (handleChange, setFieldValue, submitForm, values) => (e) => {
    handleChange(e);
    const { name, value } = e.target;
    setFieldValue(name, value);

    if (values.location && values.customDate) {
      submitForm();
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      border: 'none',
      boxShadow: 'none',
      minHeight: 'auto',
      height: '100%',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'gray',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'black',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      color: 'black',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      maxHeight: '200px',
      overflowY: 'scroll',
      scrollbarWidth: 'thin',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ccc' : 'white',
      color: 'black',
      '&:hover': {
        backgroundColor: '#eee',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <div className="main-container">
      <Toolbar />
      <Sidebar />
      <div className="content-container">
        <div className="main-content">
          <div className="management-header">
            <h3> Reports </h3>
          </div>
          <div className="manage-headings">
            <span
              style={{
                textDecoration: 'underline',
                textDecorationColor:'#8F9BC5',
                textDecorationThickness:'1.5px',
                textUnderlineOffset:'4px',
                fontWeight:'500',
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate('/pie-chart')
              }}
            >
              Waste Composition
            </span>
            <span
              style={{
                textDecoration: 'none',
                textDecorationColor:'transparent',
                textDecorationThickness:'auto',
                textUnderlineOffset:'0px',
                fontWeight: '400',
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate('/column-chart')
              }}
            >
              Waste Volume
            </span>
            <span
              style={{
                textDecoration: 'none',
                textDecorationColor: 'transparent',
                textDecorationThickness: 'auto',
                textUnderlineOffset: '0px',
                fontWeight: '400',
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate('/map-chart')
              }}
            >
              Real-time Detection
            </span>
          </div>
          <Formik
            initialValues={{ location: 'Pakistan', customDate: '2024-09-02' }}
            // validationSchema={HistorySchema}
            onSubmit={handleSubmit}
          >
            {({ handleChange, handleBlur, values, setFieldValue, submitForm }) => (
              <Form>
                <div className="history-buttons" style={{ justifyContent: 'flex-end' }}>
                  <Select
                    name="location"
                    className="history-button"
                    options={countries} // An array of options with full names
                    onChange={(selectedOption) => {
                      setFieldValue('location', selectedOption.value); // Store the full name
                      submitForm();
                    }}
                    onBlur={handleBlur}
                    value={values.location ? countries.find(option => option.value === values.location) : null}
                    placeholder="Enter loaction"
                    styles={customStyles}
                  />
                  <ErrorMessage name="location" component="div" className="error" />
                  <Field
                    name="customDate"
                    type="date"
                    className="history-button"
                    onChange={handleFieldChange(handleChange, setFieldValue, submitForm, values)}
                    onBlur={handleBlur}
                    value={values.customDate}
                  />
                  <ErrorMessage name="customDate" component="div" className="error" />
                </div>
              </Form>
            )}
          </Formik>
          { showChart ? 
            <div className="pie-chart-wrapper">
              {series.length > 0 && labels.length > 0 && (
                <ReactApexChart options={options} series={series} type="pie" width="500" />
              )}
              <div className="pie-chart-labels">
                {labels.map((label, index) => (
                  <div key={index} className="pie-chart-label">
                    <div className="color-box" style={{ backgroundColor: options.colors[index % options.colors.length] }}></div>
                    <span>{label}</span>
                  </div>
                ))}
              </div>
            </div> 
            : <h2 style={{ display: 'flex', justifyContent: 'center' }}> {message} </h2>
          }
        </div>
      </div>
    </div>
  );
}

export default PieChart;
